module.exports = __webpack_public_path__ + "static/media/18ECA19.b4dae17c.jpg";